import useTranslation from "@/hooks/use_translation";
import ErrorIcon from "@/sprout/icons/error";
import LoadingSpinner from "@/sprout/loading_spinner";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

const ErrorState = ({ renderHeader }: { renderHeader: () => JSX.Element }) => {
  const { t } = useTranslation("dashboard");

  return (
    <>
      {renderHeader()}
      <div className="flex gap-1">
        <ErrorIcon color="error-red" />
        {t("errors.there_was_a_problem")}
      </div>
    </>
  );
};

const LoadingState = ({ renderHeader }: { renderHeader: () => JSX.Element }) => (
  <>
    {renderHeader()}
    <LoadingSpinner size="medium" />
  </>
);

const StateWrapper = ({ children, className }: { children: React.ReactNode; className: string }) =>
  className ? <div className={className}>{children}</div> : <>{children}</>;

export const DashboardSuspense = ({
  renderHeader,
  className,
  children,
}: {
  renderHeader: () => JSX.Element;
  className?: string;
  children: React.ReactNode;
}) => {
  const wrappedState = (State: typeof ErrorState | typeof LoadingState) => (
    <StateWrapper className={className || ""}>
      <State renderHeader={renderHeader} />
    </StateWrapper>
  );

  return (
    <ErrorBoundary fallback={wrappedState(ErrorState)}>
      <Suspense fallback={wrappedState(LoadingState)}>{children}</Suspense>
    </ErrorBoundary>
  );
};
